import { FC } from "react";
import { Portal, PortalProps } from "./Portal";

interface ConditionallyRenderedPortalProps extends PortalProps {
  isEnabled: boolean;
}

export const ConditionallyRenderedPortal: FC<
  ConditionallyRenderedPortalProps
> = ({ children, isEnabled }) => {
  if (isEnabled) {
    return <Portal>{children}</Portal>;
  }

  return children;
};
